import { Component, OnInit } from '@angular/core';
import { TermsService } from '../../Services/terms.service';
import { TermsData } from '../../Models/terms';
import { CustomToasterServiceService } from '../../Services/custom-toaster-service.service';

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.css']
})
export class PreferenceComponent implements OnInit {
  terms: TermsData[] = [];
  touristTerms: TermsData | undefined;
  tourguideTerms: TermsData | undefined;
  paymentTerms: TermsData | undefined;
  // Uploading flags
  isUploadingTourist = false;
  isUploadingTourguide = false;
  isUploadingPayment = false;

  constructor(
    private termsService: TermsService,
    private toasterService: CustomToasterServiceService
  ) { }

  ngOnInit() {
    this.fetchTerms();
  }

  fetchTerms() {
    this.termsService.getTerms().subscribe({
      next: (data) => {
        this.terms = data;
        this.touristTerms = data.find(t => t.userType?.toLowerCase() === 'tourist');
        this.tourguideTerms = data.find(t => t.userType?.toLowerCase() === 'tourguide');
        this.paymentTerms = data.find(t => t.userType?.toLowerCase() === 'payment');
      },
      error: (err) => console.error('Error fetching terms', err)
    });
  }

  onFileSelected(event: any, userType: string) {
    const file: File = event.target.files[0];
    if (file) {
      if (userType === 'Tourist') this.isUploadingTourist = true;
      if (userType === 'Tourguide') this.isUploadingTourguide = true;
      if (userType === 'Payment') this.isUploadingPayment = true;

      this.termsService.uploadTerms(file, userType).subscribe({
        next: (response) => {
          console.log(response.message);
          this.toasterService.success(`${userType} Terms Uploaded Successfully`);
          this.fetchTerms(); // Refresh the list
          if (userType === 'Tourist') this.isUploadingTourist = false;
          if (userType === 'Tourguide') this.isUploadingTourguide = false;
          if (userType === 'Payment') this.isUploadingPayment = false;
        },
        error: (err) => {
          console.error('Error uploading terms', err);
          if (userType === 'Tourist') this.isUploadingTourist = false;
          if (userType === 'Tourguide') this.isUploadingTourguide = false;
          if (userType === 'Payment') this.isUploadingPayment = false;
        }
      });
    }
    // Set value to empty to allow re-uploading the same file if needed
    event.target.value = '';
  }
}
